import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseServerTime } from '@/api/responses/serverTimes'

export namespace ServerTimesApi {
  /**
   * サーバ時刻取得API
   *
   * @returns サーバ時刻
   */
  export async function getTime(): Promise<ApiResponseServerTime> {
    return await ApiBase.get('/times')
  }
}
